/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, createContext, useEffect, useContext, useCallback } from 'react'
import { AuthSome } from '../../Config/Permisos';
import { conCotizacion } from '../../Models/Ventas'
import { Estado, EstadoNull, GeneralFila, updateOrPush } from '../../Models/General';
import { formatoHora } from '../../Utiles/Formatos';
import { ClientesContext, ClientesType } from './Cliente';
import { ProductosContext, ProductosType } from '../Producto';
import { semaforo } from '../../Utiles/Semaforo';
export interface CotizacionType extends ClientesType, ProductosType {
    estCotizacion: Estado
    Cotizaciones: GeneralFila[]
    actCotizacion: () => void
}
export const CotizacionContext = createContext<CotizacionType | null>(null)
export default function CotizacionProvider({ children }: { children: any }) {
    const [Cotizacion, setCotizacion] = useState<GeneralFila[]>([]);
    const cliente = useContext(ClientesContext) as ClientesType;
    const pruducto = useContext(ProductosContext) as ProductosType;
    const [est, setest] = useState(EstadoNull);
    const s = semaforo();
    const update = useCallback(() => {
        if (s.isTurn('Cotizacion'))
            if (AuthSome(['FACTURA', 'NOTA', 'COTIZACION'])) conCotizacion().cambios((data: any[]) => {
                setest({ status: 3, hora: formatoHora(conCotizacion().state) })
                setCotizacion(updateOrPush(data, Cotizacion, conCotizacion()))
            }, s.next)
            else s.next()
    }, [Cotizacion]);
    useEffect(() => {
        if (conCotizacion().state !== '') setest({ status: 3, hora: formatoHora(conCotizacion().state) })
        if (AuthSome(['FACTURA', 'NOTA', 'COTIZACION'])) conCotizacion().cargarListaCache(setCotizacion);
        s.add('Cotizacion');
        return () => s.clean('Cotizacion');
    }, []);
    useEffect(() => {
        let interval = setInterval(update, 100)
        return () => clearInterval(interval)
    }, [Cotizacion]);
    return <CotizacionContext.Provider value={{
        ...cliente, ...pruducto,
        estCotizacion: est,
        Cotizaciones: Cotizacion,
        actCotizacion: update
    }}>
        {children}
    </CotizacionContext.Provider>
}
export const SeccionConsumer = CotizacionContext.Consumer;